import { mutationOptions } from "@tanstack/react-query";
import { z } from "zod";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { api } from "./apiClient";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/ReportExport`;

const PDFReportsFormTypeSchema = z.enum(["privacyRegistration", "privacyProcessorRegistration"]);
export type PDFReportsFormType = z.infer<typeof PDFReportsFormTypeSchema>;

const RequestPDFReportsPayloadSchema = z.object({
  formType: PDFReportsFormTypeSchema,
  filters: z.object({
    questionIds: z.array(z.string()),
    responseIds: z.array(z.string()),
    metadataFields: z.array(z.string()),
  }),
});

type RequestPDFReportsPayload = z.infer<typeof RequestPDFReportsPayloadSchema>;

export const requestPDFReportsMutationOptions = () =>
  mutationOptions({
    mutationFn: async (payload: RequestPDFReportsPayload) => {
      const parsedPayload = RequestPDFReportsPayloadSchema.parse(payload);
      return await api.post(`${BASE_ENDPOINT}/request-download`, parsedPayload);
    },
  });

export const downloadPDFReportsMutationOptions = () =>
  mutationOptions({
    mutationFn: (token: string | null) => {
      if (!token) throw new Error("Token is required");
      return api.get(`${BASE_ENDPOINT}/download/${token}`) as Promise<Response>;
    },
  });
